package component

import com.github.quillraven.fleks.*
import com.soywiz.korge.view.camera.*
import org.jbox2d.common.*
import system.single.*
import utils.*

class PlayerComponent(
    val abilitySelector: AbilitySelector,
    val playerMetadata: PlayerMetadata,
    val cameraContainer: CameraContainer
) : Component<PlayerComponent> {
    var direction = BodyDirection.RIGHT
    var isDashActive = false

    var prevCameraPos = Vec2()

    override fun type() = PlayerComponent

    companion object : ComponentType<PlayerComponent>()
}

enum class BodyDirection {
    RIGHT, LEFT
}

enum class Abilities {
    NONE,
    TRAP,
    FIRE_BOLT,
    FROST_BOLT
}
